import { useNavigate } from "react-router-dom";
import React from "react";
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";

function getTheCurrentUrl() {
  const url = window.location.pathname;
  const pagename = url.split("/")[1];
  return pagename;
}
function GoBackButton() {
  const pagename = getTheCurrentUrl();
  const navigate = useNavigate();
  const useStyles = makeStyles((theme) => ({
    gobackbtn: {
      padding: "4px 8px",
      fontSize: "13px",
      textTransform: "none",
      backgroundColor: "#ffffff",
      marginRight: "12px",
      [theme.breakpoints.down('xs')]: {
        marginBottom: "8px",
      },
    },
  }));
  const classes = useStyles();

  return (
    <>
      {pagename === "pending-order" && (
        <>
          <Button
            className={classes.gobackbtn}
            variant="outlined"
            color="primary"
            size="small"
            onClick={() =>
              navigate(`/pending-order/${localStorage.getItem("PendingNewPage")}`)
            }
          >
            Back
          </Button>
        </>
      )}
      {pagename === "important-order" && (
        <>
          <Button
            className={classes.gobackbtn}
            variant="outlined"
            color="primary"
            size="small"
            onClick={() =>
              navigate(`/important-order/${localStorage.getItem("ImportantNewPage")}`)
            }
          >
            Back
          </Button>
        </>
      )}
      {pagename === "orders" && (
        <Button
          className={classes.gobackbtn}
          variant="outlined"
          color="primary"
          size="small"
          onClick={() =>
            navigate(`/orders/${localStorage.getItem("OrderNewPage")}`)
          }
        >
          Back
        </Button>
      )}
      {pagename === "print" && (
        <Button
          className={classes.gobackbtn}
          variant="outlined"
          color="primary"
          size="small"
          onClick={() =>
            navigate(`/print/${localStorage.getItem("PrintNewPage")}`)
          }
        >
          Back
        </Button>
      )}
      {pagename === "fulfilled" && (
        <Button
          className={classes.gobackbtn}
          variant="outlined"
          color="primary"
          size="small"
          onClick={() =>
            navigate(`/fulfilled/${localStorage.getItem("FulfilledPage")}`)
          }
        >
          Back
        </Button>
      )}
    </>
  );
}
export default GoBackButton;
